import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

const EnginePositionsTable = ({ rows = [] }) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Engine Positions</Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Symbol</TableCell>
              <TableCell align="right">Long Size</TableCell>
              <TableCell align="right">Short Size</TableCell>
              <TableCell align="right">Total PnL</TableCell>
              <TableCell align="right">Total ROE</TableCell>
              <TableCell>Source</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={`${row.symbol}-${row.user_id || row.id || 'row'}`}>
                <TableCell>{row.symbol}</TableCell>
                <TableCell align="right">{Number(row.long?.size || 0).toFixed(2)}</TableCell>
                <TableCell align="right">{Number(row.short?.size || 0).toFixed(2)}</TableCell>
                <TableCell align="right">{Number(row.totalPnl || 0).toFixed(2)}</TableCell>
                <TableCell align="right">{Number(row.totalRoe || 0).toFixed(2)}%</TableCell>
                <TableCell>{row.source || '-'}</TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={6}>
                  <Box sx={{ py: 2, textAlign: 'center', color: 'text.secondary' }}>
                    No positions
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default EnginePositionsTable;
